<div class="modal-header">
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  <div class="dialog-content" [innerHTML]="dialogContent"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onClose()">
    Close
  </button>
</div>
